<template>
  <el-card class="collection-card" @click="handleClick">
    <div class="card-layout">
      <div class="content-cover">
        <img 
          v-if="collection.cover_url" 
          :src="collection.cover_url" 
          :alt="collection.title"
        />
        <div v-else class="cover-placeholder">
          <i class="el-icon-picture-outline"></i>
        </div>
      </div>
      <div class="content-info">
        <h4>{{ collection.title }}</h4>
        <p>{{ collection.description }}</p>
        <div class="creator-info" v-if="collection.creator_name">
          <span class="by-text">By</span>
          <img
            v-if="collection.creator_avatar_address_small"
            :src="collection.creator_avatar_address_small"
            class="creator-avatar"
            :alt="collection.creator_name"
          />
          <div v-else class="creator-avatar-placeholder">
            {{ collection.creator_name.charAt(0).toUpperCase() }}
          </div>
          <span class="creator-name">{{ collection.creator_name }}</span>
        </div>
        <div class="collection-stats">
          <span v-if="hasCustomPrice">
            <i class="el-icon-money"></i>
            <span class="original-price">${{ collection.usd_price }}</span>
            <span class="custom-price">{{ collection.custom_price === 0 ? 'FREE' : `$${collection.custom_price}` }}</span>
            <span class="discount-badge">{{ discountPercentage }}% OFF</span>
          </span>
          <span v-else>
            <i class="el-icon-money"></i>
            {{ collection.usd_price ? `$${collection.usd_price}` : 'FREE' }}
          </span>
        </div>
      </div>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'CollectionCard',
  props: {
    collection: {
      type: Object,
      required: true
    }
  },
  computed: {
    hasCustomPrice() {
      return this.collection.custom_price !== undefined
        && this.collection.custom_price !== null
        && Number(this.collection.custom_price) < Number(this.collection.usd_price);
    },
    discountPercentage() {
      if (!this.hasCustomPrice) return 0;
      const original = Number(this.collection.usd_price);
      const custom = Number(this.collection.custom_price);
      if (original === 0) return 0;
      return Math.round(((original - custom) / original) * 100);
    }
  },
  methods: {
    handleClick() {
      this.$emit('click', this.collection)
    }
  }
}
</script>

<style lang="scss" scoped>
.collection-card {
  cursor: pointer;
  transition: transform 0.2s;
  margin: 12px 0;

  &:hover {
    transform: translateY(-4px);
  }

  .card-layout {
    display: flex;
    gap: 16px;
    margin: -20px;
  }

  .content-cover {
    width: 120px;
    height: 168px;
    flex-shrink: 0;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 4px;
    }

    .cover-placeholder {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #f5f7fa;
      color: #909399;
      font-size: 20px;
      border-radius: 4px;
    }
  }

  .content-info {
    padding: 20px 20px 20px 0;
    flex: 1;
    min-width: 0;

    h4 {
      margin: 0 0 12px;
      color: #303133;
      font-size: 16px;
      font-weight: 600;
    }

    p {
      margin: 0 0 12px;
      color: #606266;
      font-size: 14px;
      line-height: 1.5;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .creator-info {
      display: flex;
      align-items: center;
      gap: 8px;
      margin-bottom: 12px;

      .by-text {
        font-size: 13px;
        color: #909399;
      }

      .creator-avatar {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        object-fit: cover;
        border: 2px solid #e0e0e0;
      }

      .creator-avatar-placeholder {
        width: 24px;
        height: 24px;
        border-radius: 50%;
        background: #e0e0e0;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: 600;
        color: #666;
        border: 2px solid #e0e0e0;
      }

      .creator-name {
        font-size: 13px;
        color: #909399;
      }
    }

    .collection-stats {
      display: flex;
      gap: 16px;
      color: #909399;
      font-size: 13px;

      span {
        display: flex;
        align-items: center;
        gap: 4px;

        i {
          font-size: 14px;
          color: #409EFF;
        }
      }

      .original-price {
        text-decoration: line-through;
        color: #909399;
        font-size: 12px;
      }

      .custom-price {
        color: #f56c6c;
        font-weight: 600;
      }

      .discount-badge {
        background: #f56c6c;
        color: white;
        padding: 1px 4px;
        border-radius: 3px;
        font-size: 11px;
        font-weight: 500;
      }
    }
  }
}
</style> 